<script setup lang="ts">
/** 分段按钮组（线型等预设选择） */
const props = defineProps<{
  value: string;
  options: ReadonlyArray<{ value: string; label: string }>;
}>();
const emit = defineEmits<{ change: [value: string] }>();
</script>

<template>
  <div class="seg">
    <button
      v-for="opt in props.options"
      :key="opt.value"
      :class="{ 'is-active': opt.value === props.value }"
      @click="emit('change', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
